import { useAppSelector } from 'features/app/hooks';
import {
  VrsCallComments,
  VrsCallCommentsAbuse,
  VrsCallCommentsBugReport,
  VrsCallCommentsEnd,
  VrsCallCommentsNonBillable,
} from 'features/call/vrs-call-comments/components';
import { ReportType } from 'features/call/vrs-call-comments/enums';
import { reportTypeSelector } from 'features/call/vrs-call-comments/store';
import { useVrsCallHeader } from 'features/call/vrs-call/hooks';
import { MainTemplate } from 'features/ui/elements';

export const VrsCallSurvey = () => {
  const reportType = useAppSelector(reportTypeSelector);
  const { header } = useVrsCallHeader();

  return (
    <MainTemplate header={header}>
      {reportType === ReportType.DEFAULT && <VrsCallComments />}
      {reportType === ReportType.NON_BILLABLE && <VrsCallCommentsNonBillable />}
      {reportType === ReportType.ABUSE && <VrsCallCommentsAbuse />}
      {reportType === ReportType.BUG_REPORT && <VrsCallCommentsBugReport />}
      {reportType === ReportType.END && <VrsCallCommentsEnd />}
    </MainTemplate>
  );
};
